import { apiUrl } from './api';

/**
 * HTTP round trips to the server, ascending (failed pings left out). The pings go out together:
 * over one HTTP/2 connection each still measures a full round trip.
 */
export async function measureRtt(samples = 3): Promise<number[]> {
  const one = async () => {
    const t0 = performance.now();
    const ok = await fetch(apiUrl('/api/health'), { cache: 'no-store' }).then(
      (r) => r.ok,
      () => false,
    );
    return ok ? performance.now() - t0 : null;
  };
  const all = await Promise.all(Array.from({ length: samples }, one));
  return all.filter((x): x is number => x !== null).sort((a, b) => a - b);
}
